import React, { useState, useEffect } from "react";
import { RxLapTimer } from "react-icons/rx";
import { useLocation } from "react-router-dom";
import Swal from "sweetalert2";

const AutoLogoutWarning = (props) => {
  const [counter, setCounter] = useState(1800); // Initial countdown value
  const location = useLocation(); // React Router hook to get the current URL

  useEffect(() => {
    // Reset the counter when the URL changes
    setCounter(1800);
  }, [location]);

  useEffect(() => {
    // Countdown timer logic
    if (counter > 0) {
      const timer = setTimeout(() => setCounter(counter - 1), 1000);
      return () => clearTimeout(timer); // Cleanup on unmount or counter update
    } else {
      Swal.fire({
        title: "Session Expired",
        text: "Your session has expired. Click OK to refresh, or you’ll be logged out automatically.",
        icon: "warning",
        showConfirmButton: true,
        confirmButtonText: "OK",
        allowOutsideClick: false, // Prevent closing without interaction
        timer: 5000, // Automatically close the modal after 5 seconds
        timerProgressBar: true, // Show a progress bar for the timer
      }).then((result) => {
        if (result.isConfirmed) {
          // User clicked "OK" - Reload the page
          window.location.reload();
        } else if (result.dismiss === Swal.DismissReason.timer) {
          // User did not click "OK" and the modal was closed automatically
          Digit.UserService.logout(); // Execute logout
        }
      });
    }
  }, [counter]);

  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins.toString().padStart(2, "0")}:${secs.toString().padStart(2, "0")}`;
  };

  return (
    <p
      className="mx-2"
      style={{
        color: props.color ? props.color : "#ffffff",
        display: "flex", // Align children linearly
        alignItems: "center", // Vertically center align items
        gap: "8px", // Add spacing between the icon and text
      }}
    >
      <span>
        <RxLapTimer width={50}/>
      </span>
      <span>{formatTime(counter)}</span>
    </p>
  );
};

export default AutoLogoutWarning;
